(function () {
  var open = null;
  var mq = window.matchMedia('(max-width: 749px)');

  function close(pack, focusToggle) {
    if (!pack) return;
    var panel = pack.querySelector('.bnp-pack__panel');
    var tog = pack.querySelector('.bnp-pack__toggle');
    panel.hidden = true;
    tog.setAttribute('aria-expanded', 'false');
    pack.classList.remove('is-open');
    document.documentElement.classList.remove('bnp-sheet-open');
    if (focusToggle) tog.focus();
    if (open === pack) open = null;
  }

  function show(pack) {
    if (open && open !== pack) close(open);
    var panel = pack.querySelector('.bnp-pack__panel');
    var tog = pack.querySelector('.bnp-pack__toggle');
    panel.hidden = false;
    tog.setAttribute('aria-expanded', 'true');
    pack.classList.add('is-open');
    if (mq.matches) document.documentElement.classList.add('bnp-sheet-open');
    var checked = panel.querySelector('input:checked') || panel.querySelector('input');
    if (checked) checked.focus();
    open = pack;
  }

  document.addEventListener('click', function (e) {
    var tog = e.target.closest('.bnp-pack__toggle');
    if (tog) {
      var pack = tog.closest('.bnp-pack');
      if (pack.classList.contains('is-open')) close(pack, true); else show(pack);
      return;
    }
    if (e.target.closest('.bnp-pack__close')) { close(open, true); return; }
    if (open && !e.target.closest('.bnp-pack__panel')) close(open);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) close(open, true);
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.bnp-pack__opt input')) return;
    var pack = input.closest('.bnp-pack');
    var form = input.closest('form');
    var qty = parseInt(input.value, 10) || 1;
    form.querySelector('.bnp-qty').value = qty;
    pack.querySelector('.bnp-pack__current').textContent = qty + ' Pack';
    pack.querySelector('.bnp-bar__total').textContent = input.getAttribute('data-total');
    pack.querySelector('.bnp-bar__unit').textContent = '(' + input.getAttribute('data-each') + '/unit)';
    var label = form.querySelector('.bnp-btn-label');
    if (label) label.textContent = qty === 1 ? 'Add to cart' : 'Add ' + qty + ' to cart';
    setTimeout(function () { close(pack, true); }, 150);
  });
})();
